import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Constants } from 'src/app/helper/constants';
import {
  ISiteRequestDetails,
  ISiteRequestAssessmentResponse,
  ISiteRequestUpdateStatus,
  ISiteRequestUpdateStatusResponse,
  IPreApprovedSiteRequestResult,
  IDynamicQRCodeResult,
} from 'src/app/feature/site-rediness-matrix/models/request';
import { IGetSiteRequestsResult, ISubmitApprovalResult, IRequestApproval } from 'src/app/feature/approvals/models/approvals';
import { GET_SITE_REQUEST_APPROVALS, POST_SITE_REQUEST_APPROVALS } from 'src/app/feature/approvals/helper/constanst';
import { GET_SITE_REQUEST_DETAILS } from 'src/app/feature/scan-qr-code/constants/constants';


@Injectable({
  providedIn: 'root'
})
export class SiterequestService {

  siteRequestFilter = new BehaviorSubject<number>(0);
  siteApprovalFilter = new BehaviorSubject<number>(1);

  constructor(private httpClient: HttpClient) {
    // Do Nothing
  }


  postSiteRequesttData = (siteRequestDetailstObj: ISiteRequestDetails): Observable<ISiteRequestAssessmentResponse> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<ISiteRequestAssessmentResponse>(Constants.POST_SITE_REQUEST_DETAILS, siteRequestDetailstObj, options);
  }

  setSiteRequestFilter = (value: number) => {
    this.siteRequestFilter.next(value);
  }
  getSiteRequestFilter = (): Observable<number> => {
    return this.siteRequestFilter.asObservable();
  }
  setSiteApprovalFilter = (value: number) => {
    this.siteApprovalFilter.next(value);
  }
  getSiteApprovalFilter = (): Observable<number> => {
    return this.siteApprovalFilter.asObservable();
  }
  getSiteRequestData = (): Observable<IGetSiteRequestsResult> => {
    return this.httpClient.get<IGetSiteRequestsResult>(GET_SITE_REQUEST_APPROVALS);
  }

  updateSiteRequestData = (updatesiteRequestObj: ISiteRequestUpdateStatus): Observable<ISiteRequestUpdateStatusResponse> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<ISiteRequestUpdateStatusResponse>(Constants.UPDATE_SITE_REQUEST_DETAILS, updatesiteRequestObj, options);
  }
  postSiteRequestApproval = (approvalObj: IRequestApproval): Observable<ISubmitApprovalResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<ISubmitApprovalResult>(POST_SITE_REQUEST_APPROVALS, approvalObj, options);
  }
  getSiteRequestDetails = (siteRequestData: ISiteRequestDetails): Observable<IPreApprovedSiteRequestResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };
    return this.httpClient.post<IPreApprovedSiteRequestResult>(GET_SITE_REQUEST_DETAILS, siteRequestData, options);
  }
  postAdditionalDetailsForQRCode = (data: ISiteRequestDetails): Observable<IDynamicQRCodeResult> => {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const options = { headers };

    return this.httpClient.post<IDynamicQRCodeResult>(Constants.GET_DYNAMIC_QR_CODE_FOR_USER_FLOW, data, options);
  }

  getSiteRequestQRCodeCrewDetails = (requestno: number, memberid: number): Observable<any> => {
    return this.httpClient.get<any>(Constants.GET_SITE_REQUEST_QRCODE_CREWDETAILS + 'requestno=' + requestno + '&memberid=' + memberid);
  }

}


